import React from 'react';
import Grid from '@mui/material/Grid';
import kebabCase from 'lodash/kebabCase';
import PaymentsIcon from '@mui/icons-material/Payment';
import FlightIcon from '@mui/icons-material/Flight';
import EmailIcon from '@mui/icons-material/Email';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import DrawIcon from '@mui/icons-material/Draw';
import RuleIcon from '@mui/icons-material/Rule';
import HistoryIcon from '@mui/icons-material/History';

import ColumnLinks from '../../../../../components/ColumnLinks';

import settingsHomePageStyles from './settingsHomePageStyles';
export const columns1 = [
    {
        title: 'Payment Options',
        link: kebabCase('Payment Options'),
        body: 'TBD',
        // eslint-disable-next-line react/display-name
        icon: PaymentsIcon,
        notDeveloped: false,
        permissionId: 'setup.payment_option:view'
    }
];

export const columns2 = [
    {
        title: 'Amadeus',
        link: kebabCase('Amadeus'),
        body: 'AMADEUS',
        // eslint-disable-next-line react/display-name
        icon: FlightIcon,
        notDeveloped: false,
        permissionId: 'system.amadeus:view'
    }
];

export const columns3 = [
    {
        title: 'Email Settings',
        link: kebabCase('Email Settings'),
        body: 'Email Settings',
        // eslint-disable-next-line react/display-name
        icon: EmailIcon,
        notDeveloped: false,
        permissionId: 'system.email_settings:edit'
    },
    {
        title: 'Jira Settings',
        link: kebabCase('Jira Settings'),
        body: 'Jira Integration',
        // eslint-disable-next-line react/display-name
        icon: BugReportOutlinedIcon,
        notDeveloped: false,
        permissionId: 'system.jira:edit'
    }
];

export const columns4 = [
    {
        title: 'My Signature',
        link: kebabCase('My Signature'),
        body: 'Draw and save your digital signature for document approvals.',
        icon: DrawIcon,
        notDeveloped: false,
        permissionId: 'system.signature:view'
    }
];

export const columns5 = [
    {
        title: 'Tour Registration Rules',
        link: kebabCase('Tour Registration Rules'),
        body: 'Minimum deposit and full-payment window for customer-facing tour registration.',
        icon: RuleIcon,
        notDeveloped: false,
        permissionId: 'setup.tour_registration_rule:view'
    },
    {
        title: 'Travel File Log',
        link: kebabCase('Travel File Log'),
        body: 'Choose which actions are recorded in a travel file’s log. Everything is on by default.',
        icon: HistoryIcon,
        notDeveloped: false,
        permissionId: 'system.app_settings:edit'
    }
];

const SettingsHomePage = () => {
    const classes = settingsHomePageStyles();

    return (
        <Grid container className={classes.container}>
            <ColumnLinks
                basePath="administration/setup/general/settings"
                items={columns1}
                className={classes.columnStyle}
            />
            <ColumnLinks
                basePath="administration/setup/general/settings"
                items={columns2}
                className={classes.columnStyle}
            />
            <ColumnLinks
                basePath="administration/setup/general/settings"
                items={columns3}
                className={classes.columnStyle}
            />
            <ColumnLinks
                basePath="administration/setup/general/settings"
                items={columns4}
                className={classes.columnStyle}
            />
            <ColumnLinks
                basePath="administration/setup/general/settings"
                items={columns5}
                className={classes.columnStyle}
            />
        </Grid>
    );
};

export default SettingsHomePage;
